module.exports = __webpack_public_path__ + "static/media/Jeff.39ede7db.webp";